import React from 'react';
import { Zap, TrendingUp, Award } from 'lucide-react';

/**
 * Motivational Feedback Component
 * Displays live XP accumulation and encouraging messages
 */
export default function MotivationalFeedback({ 
  totalXPEarned, 
  completedSegments, 
  totalSegments 
}) {
  
  const progressPercentage = (completedSegments / totalSegments) * 100;

  const getEncouragingMessage = () => {
    if (progressPercentage === 0) {
      return "Let's warm up that voice! 🎤";
    } else if (progressPercentage < 25) {
      return "Great start! Keep that energy going! 💪";
    } else if (progressPercentage < 50) {
      return "You're doing amazing! Halfway there! 🔥";
    } else if (progressPercentage < 75) {
      return "Fantastic progress! Don't stop now! ⭐";
    } else if (progressPercentage < 100) {
      return "Almost there! Finish strong! 🎯";
    } else {
      return "Incredible work! You're a star! 🌟";
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* XP Earned */}
      <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 backdrop-blur-md rounded-2xl p-6 border border-yellow-400/30">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-2 bg-yellow-500/30 rounded-lg">
            <Zap className="w-6 h-6 text-yellow-300" />
          </div>
          <h3 className="text-white font-bold">XP Earned</h3>
        </div>
        <div className="text-4xl font-bold text-white mb-2">
          {totalXPEarned}
        </div>
        <p className="text-yellow-200 text-sm">
          Keep practicing to level up!
        </p>
      </div>

      {/* Progress Stats */}
      <div className="bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-md rounded-2xl p-6 border border-purple-400/30">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-2 bg-purple-500/30 rounded-lg">
            <TrendingUp className="w-6 h-6 text-purple-300" />
          </div>
          <h3 className="text-white font-bold">Segments</h3>
        </div>
        <div className="text-4xl font-bold text-white mb-2">
          {completedSegments} / {totalSegments}
        </div>
        <p className="text-purple-200 text-sm">
          {Math.floor(progressPercentage)}% Complete
        </p>
      </div>

      {/* Motivation */}
      <div className="bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-md rounded-2xl p-6 border border-green-400/30">
        <div className="flex items-center gap-3 mb-3">
          <div className="p-2 bg-green-500/30 rounded-lg">
            <Award className="w-6 h-6 text-green-300" />
          </div>
          <h3 className="text-white font-bold">Motivation</h3>
        </div>
        <p className="text-white text-lg font-medium">
          {getEncouragingMessage()}
        </p>
      </div>
    </div>
  );
}